import React, { FC, useEffect } from 'react'
import { RecoilRoot } from 'recoil'
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client'
import { IProductPricedPerCollectionLevel1 as Product } from '@engyalo/storefront-types/lib/graphql/product'
import { resetIdentity } from '@engyalo/storefront-events'

import { Routes } from './routes'

const storefrontApiFallback = `https://api-staging2.yalochat.com/storefront-user/v1/user/storefronts?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJKQURaQ1RRaE1GdUI2Rmc0eHRiT21Td0hRQmRnVkVUbSJ9.6ByX-cTvN1gnFDYuSoaYa3NVXV27_mWfIxrxtCmR3Lw`
// const storefrontApiFallback = `http://localhost:4001/v1/user/storefronts`

const client = new ApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          productsPricedPerCollection: {
            keyArgs(args: Record<string, string> | null): string[] {
              const [productFilterID, productFilterName] = ['productFilterID', 'productFilterName']

              if (args?.[productFilterID]) {
                return [productFilterID]
              }

              if (args?.[productFilterName]) {
                return [productFilterName]
              }

              return []
            },
          },
        },
      },
      Collection: {
        fields: {
          Product: {
            merge(_ignored: Product[], incoming: Product[]): Product[] {
              return incoming
            },
          },
        },
      },
    },
  }),
  uri: process.env.REACT_APP_STOREFRONT_API || storefrontApiFallback,
})

const App: FC = () => {
  useEffect(() => {
    resetIdentity()
  }, [])

  return (
    <ApolloProvider client={client}>
      <div className="App" style={{ width: '100%', height: '100vh', display: 'flex' }}>
        <RecoilRoot>
          <Routes />
        </RecoilRoot>
      </div>
    </ApolloProvider>
  )
}

export default App
